import React from 'react'
import { useSelector } from 'react-redux'
import {
  getFilters,
  getIsDataFilteredOrSorted,
  getIsLoaded,
  getPage,
  getPageCount,
  getSearchString,
  getSorter,
  getSortedProducts,
} from 'domains/products/selectors'
import useAction from 'utils/useAction'
import { deleteProduct, fetchProducts } from 'actions/views/insights'
import { StyledTable, Wrapper, Buttons } from './Insights.styles'
import SearchInTableBar from 'components/SearchInTableBar'
import { Button } from 'antd'
import getColumns from './columns'
import { getRowClassByTagID, getRowKey } from 'helpers/tables'
import { FIELD_NAMES } from 'const/forms'
import { openConfirmModal, openProductModal } from 'reducers/modals/actions'
import isEqual from 'lodash/isEqual'
import { HEADER_OFFSET, PAGE_SIZE, SCROLL } from 'const/tables'

const Insights = () => {
  const isLoaded = useSelector(getIsLoaded)
  const page = useSelector(getPage)
  const search = useSelector(getSearchString)
  const pageCount = useSelector(getPageCount)
  const filters = useSelector(getFilters)
  const sorter = useSelector(getSorter)
  const dataSource = useSelector(getSortedProducts)
  const isDataFilteredOrSorted = useSelector(getIsDataFilteredOrSorted)

  const fetchProductsFunc = useAction(fetchProducts)
  const deleteProductFunc = useAction(deleteProduct)
  const openConfirmModalFunc = useAction(openConfirmModal)
  const openProductModalFunc = useAction(openProductModal)

  const onSearchStringChange = (search) =>
    fetchProductsFunc({
      page: 1,
      search,
      filters,
      sorter,
    })
  const handleEditProduct = (id) => openProductModalFunc({ id })
  const handleCreateProduct = () => openProductModalFunc()
  const handleDeleteProduct = (product) => {
    const callback = () => deleteProductFunc(product[FIELD_NAMES.id])
    const text =
      `Are you sure you want to delete product ${
        product[FIELD_NAMES.name]
      } (ID: ${product[FIELD_NAMES.id]})? ` + "This action can't be revoked."
    openConfirmModalFunc({ callback, text })
  }

  const onTableChange = (pagination, newFilters, newSorter) => {
    const pageChanged = page !== pagination.current
    const newFiltersOrSorter =
      !pageChanged &&
      (!isEqual(newFilters, filters) || !isEqual(newSorter, sorter))
    fetchProductsFunc({
      page: newFiltersOrSorter ? 1 : pagination.current,
      search,
      filters: newFilters,
      sorter: newSorter,
    })
  }

  const handleResetFilters = () =>
    fetchProductsFunc({
      search,
      page: 1,
      filters: {},
      sorter: {},
    })

  const paginationConfig = {
    position: ['bottomCenter'],
    showQuickJumper: true,
    total: pageCount * PAGE_SIZE,
    pageSize: PAGE_SIZE,
    current: page,
    showSizeChanger: false,
  }

  return (
    <Wrapper>
      <SearchInTableBar
        placeholder="Search product here"
        onSubmit={onSearchStringChange}
        value={search}
      >
        <Buttons>
          <Button
            onClick={handleCreateProduct}
            type="primary"
            disabled={!isLoaded}
          >
            Create
          </Button>
          <Button
            onClick={handleResetFilters}
            disabled={!isLoaded || !isDataFilteredOrSorted}
          >
            Reset filters
          </Button>
        </Buttons>
      </SearchInTableBar>
      <StyledTable
        onChange={onTableChange}
        showSorterTooltip={false}
        columns={getColumns(
          filters,
          sorter,
          handleEditProduct,
          handleDeleteProduct
        )}
        dataSource={dataSource}
        expandable={false}
        pagination={paginationConfig}
        sticky={isLoaded && HEADER_OFFSET}
        scroll={SCROLL}
        bordered
        loading={false}
        rowKey={getRowKey}
        rowClassName={getRowClassByTagID}
      />
    </Wrapper>
  )
}

export default Insights
